import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Modules/Sidebar/Sidebar.css";
import { useGlobal } from "../../GlobalContext.js";
import { useUI } from "../../UIContext";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Images
import TicketLogoSvg from "../../Assets/svg/tickgo-logo.svg";
import dashboard from "../../Assets/svg/dashboard.svg";
import dashboardActive from "../../Assets/svg/dashboard-active.svg";
import ticketMenu from "../../Assets/svg/ticket-menu.svg";
import ticketMenuActive from "../../Assets/svg/tickets-active.svg";
import summaryIc from "../../Assets/svg/summary_ic.svg";
import selectSummaryIc from "../../Assets/svg/select_summary_ic.svg";
import reportMenu from "../../Assets/svg/report-menu.svg";
import reportMenuActive from "../../Assets/svg/report-menu-active.svg";
import team from "../../Assets/svg/team-inactive.svg";
import teamActive from "../../Assets/svg/team-active.svg";
import project from "../../Assets/svg/project-inactive.svg";
import projectActive from "../../Assets/svg/project-active.svg";
import client from "../../Assets/svg/client-inactive.svg";
import clientActive from "../../Assets/svg/clients.svg";
import component from "../../Assets/svg/component-inactive.svg";
import componentActive from "../../Assets/svg/component-active.svg";
import mail from "../../Assets/svg/mail-config-inactive.svg";
import mailActive from "../../Assets/svg/mail-config-active.svg";
import approvalActive from "../../Assets/svg/approvalActive.svg";
import approvalInActive from "../../Assets/svg/approvalInActive.svg";
import escalationActive from "../../Assets/svg/escalation-active.svg";
import escalationInActive from "../../Assets/svg/escalation-inactive.svg";
import fieldConfigActive from "../../Assets/svg/field-config-active.svg";
import fieldConfigInActive from "../../Assets/svg/field-config-inactive.svg";
import whatsNewIcon from "../../Assets/svg/whats-new-ic.svg";
import whatsNewGif from "../../Assets/svg/whats-new.gif";
import workloadIc from "../../Assets/svg/workload-ic.svg";
import workloadActive from "../../Assets/svg/workloadActive.svg";
import budgetIc from "../../Assets/svg/Budget.svg";
import budgetActive from "../../Assets/svg/BudgetActive.svg";
import handoverActive from "../../Assets/svg/handover_active.svg";
import handoverInactive from "../../Assets/svg/handover_inactive.svg";
import junkMailActive from "../../Assets/svg/junk-mail-active.svg";
import junkMailInactive from "../../Assets/svg/junk-mail-inactive.svg";

const Sidebar = ({ selectedTab, isMobileView }) => {
  const { rolePermissionList, orgImage } = useGlobal();
  const { isCollapsed, setIsCollapsed } = useUI();
  const navigate = useNavigate();
  // const [isCollapsed, setIsCollapsed] = useState(true);
  const [hoveredTab, setHoveredTab] = useState("");

  const menuColorActive = {
    fontSize: "13.5px",
    fontWeight: "700",
    color: "#6929E2",
  };
  const menuColorInactive = {
    fontSize: "13.5px",
    fontWeight: "400",
    color: "#21272C",
  };

  const collapsedButtonStyle = (marginTop = "8px") => ({
    border: "none",
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    marginTop,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
  });

  const fullViewButtonStyle = {
    textDecoration: "none",
    border: "none",
    width: "46px",
    height: "40px",
    borderRadius: "12px",
    padding: "4px 8px",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
  };

  const fullViewRowStyle = (tabName) => ({
    marginTop: "4px",
    marginBottom: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    width: "205px",
    height: "40px",
    borderRadius: "12px",
    background:
      selectedTab === tabName || hoveredTab === tabName ? "#F7F7F7" : "#FFFFFF",
  });

  const checkPermission = (menuName, permission) =>
    rolePermissionList.some(
      (element) => element.name === menuName && element[permission] === true,
    );

  const handleMouseEnter = (tabName) => setHoveredTab(tabName);
  const handleMouseLeave = () => setHoveredTab("");

  const collapsedViewMenu = () => (
    <div
      style={{
        padding: "10px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <img
        src={orgImage != null && orgImage !== "" ? orgImage : TicketLogoSvg}
        alt=""
        className="logo"
        style={{
          cursor: "pointer",
          width: "64px",
          maxHeight: "36px",
          objectFit: "contain",
          display: "block",
          margin: "0 auto 8px auto",
        }}
        onClick={() => navigate("/dashboard")}
      />
      {/* <img src={TicketLogoSvg} alt="logo" width="62px" height="30px" /> */}

      {checkPermission("Dashboard", "menu_permission") && (
        <Link
          to="/dashboard"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("8px")}
            data-tooltip-id="dashboard-tooltip"
            data-tooltip-content="Dashboard"
          >
            <img
              src={selectedTab === "Dashboard" ? dashboardActive : dashboard}
              alt="dashboard"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </Link>
      )}
      <Tooltip id="dashboard-tooltip" place="right" positionStrategy="fixed" />
      {checkPermission("Ticket", "menu_permission") && (
        <Link
          to="/ticket"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("8px")}
            data-tooltip-id="tickets-tooltip"
            data-tooltip-content="Tickets"
          >
            <img
              src={selectedTab === "Tickets" ? ticketMenuActive : ticketMenu}
              alt="tickets"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </Link>
      )}
      <Tooltip id="tickets-tooltip" place="right" positionStrategy="fixed" />
      {checkPermission("Summary", "menu_permission") && (
        <Link
          to="/summary"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("4px")}
            data-tooltip-id="summary-tooltip"
            data-tooltip-content="Summary"
          >
            <img
              src={selectedTab === "summary" ? selectSummaryIc : summaryIc}
              alt="summary"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="summary-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
      {checkPermission("Workload", "menu_permission") && (
        <Link
          to="/workload"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("4px")}
            data-tooltip-id="workload-tooltip"
            data-tooltip-content="Workload"
          >
            <img
              src={selectedTab === "Workload" ? workloadActive : workloadIc}
              alt="workload"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="workload-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
      {checkPermission("Budget", "menu_permission") && (
        <Link
          to="/budget"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("4px")}
            data-tooltip-id="budget-tooltip"
            data-tooltip-content="Budget"
          >
            <img
              src={selectedTab === "Budget" ? budgetActive : budgetIc}
              alt="budget"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip id="budget-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )}
      {checkPermission("Report", "menu_permission") && (
        <Link
          to="/report"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("4px")}
            data-tooltip-id="report-tooltip"
            data-tooltip-content="Report"
          >
            <img
              src={selectedTab === "Report" ? reportMenuActive : reportMenu}
              alt="report"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip id="report-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )}

      {/* {(checkPermission("Junk Mail", "menu_permission") || checkPermission("Junk mail", "menu_permission") || true) && (
        <Link
          to="/junk-mail"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("4px")}
            data-tooltip-id="junk-mail-tooltip"
            data-tooltip-content="Junk Mail"
          >
            <img
              src={selectedTab === "Junk Mail" ? junkMailActive : junkMailInactive}
              alt="junk-mail"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip id="junk-mail-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )} */}

      {/* {checkPermission("WhatsNew", "menu_permission") && ( */}
      <Link
        to="/whats-new"
        style={{
          textDecoration: "none",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          className="d-flex"
          style={{
            border: "none",
            width: "40px",
            height: "40px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "4px",
            background: "linear-gradient(270deg, #DECDFF 0%, #F4EFFF 100%)",
          }}
          data-tooltip-id="whats-new-tooltip"
          data-tooltip-content="What's New"
        >
          <img
            src={whatsNewGif}
            alt="whats-new"
            className="sideimg1"
            style={{ width: "20px", height: "20px" }}
          />
        </button>
        <Tooltip
          id="whats-new-tooltip"
          place="right"
          positionStrategy="fixed"
        />
      </Link>
      {/* )} */}

      {hasAnyPermission([
        ["Handover", "menu_permission"],
        ["Team", "menu_permission"],
        ["Project", "menu_permission"],
        ["Client", "menu_permission"],
        ["Vendor", "menu_permission"],
        ["Component", "menu_permission"],
        ["Mail configuration", "menu_permission"],
        ["Approval", "menu_permission"],
        ["Escalation", "menu_permission"],
        ["Field configuration", "menu_permission"],
      ]) && (
        <div
          style={{
            fontSize: "12.5px",
            fontWeight: "500",
            color: "#8790A1",
            marginTop: "8px",
          }}
        >
          Masters
        </div>
      )}

        {/*  {(checkPermission("Handover", "menu_permission") || checkPermission("Client", "menu_permission") || true) && (
        <Link
          to="/handover"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={collapsedButtonStyle("4px")}
            data-tooltip-id="handover-tooltip"
            data-tooltip-content="Handover"
          >
            <img
              src={selectedTab === "Handover" ? handoverActive : handoverInactive}
              alt="handover"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip id="handover-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )} */}

      {checkPermission("Client", "menu_permission") && (
        <Link
          to="/client/list"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="client-tooltip"
            data-tooltip-content="Client"
          >
            <img
              src={selectedTab === "Client" ? clientActive : client}
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
              alt="client"
            />
          </button>
          <Tooltip id="client-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )}

      {checkPermission("Project", "menu_permission") && (
        <Link
          to="/project"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="project-tooltip"
            data-tooltip-content="Project"
          >
            <img
              src={selectedTab === "Project" ? projectActive : project}
              alt="project"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="project-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
      {checkPermission("Team", "menu_permission") && (
        <Link
          to="/team"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="team-tooltip"
            data-tooltip-content="Team"
          >
            <img
              src={selectedTab === "Team" ? teamActive : team}
              alt="team"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip id="team-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )}

      {checkPermission("Vendor", "menu_permission") && (
        <Link
          to="/vendor/list"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="vendor-tooltip"
            data-tooltip-content="Vendor"
          >
            <img
              src={selectedTab === "Vendor" ? projectActive : project}
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
              alt="vendor"
            />
          </button>
          <Tooltip id="vendor-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )}
      {checkPermission("Component", "menu_permission") && (
        <Link
          to="/component"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="component-tooltip"
            data-tooltip-content="Component"
          >
            <img
              src={selectedTab === "Component" ? componentActive : component}
              alt="component"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="component-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
      {checkPermission("Mail configuration", "menu_permission") && (
        <Link
          to="/mail/list"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="config-tooltip"
            data-tooltip-content="Mail Configuration"
          >
            <img
              src={selectedTab === "Mail Configuration" ? mailActive : mail}
              alt="mail"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip id="config-tooltip" place="right" positionStrategy="fixed" />
        </Link>
      )}
      {checkPermission("Approval", "menu_permission") && (
        <Link
          to="/approval/list"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="approval-tooltip"
            data-tooltip-content="Approval"
          >
            <img
              src={
                selectedTab === "Approval" ? approvalActive : approvalInActive
              }
              alt="approval"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="approval-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
      {checkPermission("Escalation", "menu_permission") && (
        <Link
          to="/escalation/list"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="escalation-tooltip"
            data-tooltip-content="Escalation"
          >
            <img
              src={
                selectedTab === "Escalation"
                  ? escalationActive
                  : escalationInActive
              }
              alt="escalation"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="escalation-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
      {checkPermission("Field configuration", "menu_permission") && (
        <Link
          to="/register/list"
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <button
            className="d-flex"
            style={{
              border: "none",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
            data-tooltip-id="field-config-tooltip"
            data-tooltip-content="Field Configuration"
          >
            <img
              src={
                selectedTab === "Field configuration"
                  ? fieldConfigActive
                  : fieldConfigInActive
              }
              alt="field-config"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <Tooltip
            id="field-config-tooltip"
            place="right"
            positionStrategy="fixed"
          />
        </Link>
      )}
    </div>
  );
  const hasAnyPermission = (permissionsArray) => {
    // permissionsArray = [["Team", "menu_permission"], ["Project", "menu_permission"], ...]
    return permissionsArray.some(
      ([menuName, permission]) =>
        rolePermissionList.findIndex(
          (el) =>
            el.name === menuName &&
            el.menu_permission === true &&
            el[permission] === true,
        ) > -1,
    );
  };

  const fullViewMenu = () => (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={orgImage != null && orgImage !== "" ? orgImage : TicketLogoSvg}
          alt="logo"
          width="auto"
          height="40px"
          className="mt-2 mb-2"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/dashboard")}
        />
        {/* <img
          src={TicketLogoSvg}
          alt="logo"
          width="142px"
          height="40px"
          className="mt-2 mb-2"
        /> */}
      </div>
      <div
        style={{
          fontSize: "12.5px",
          fontWeight: "500",
          color: "#8790A1",
        }}
      >
        Main Menu
      </div>
      {checkPermission("Dashboard", "menu_permission") && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/dashboard"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Dashboard")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("Dashboard")}
          >
            <button
              className="d-flex"
              style={fullViewButtonStyle}
            >
              <img
                src={selectedTab === "Dashboard" ? dashboardActive : dashboard}
                alt="dashboard"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Dashboard" ? menuColorActive : menuColorInactive
              }
            >
              Dashboard
            </div>
            {selectedTab === "Dashboard" && (
              <div
                style={{
                  position: "absolute",
                  right: "0",
                  top: "0",
                  bottom: "0",
                  width: "5px",
                  borderRadius: "0px 12px 12px 0px",
                }}
              />
            )}
          </div>
        </Link>
      )}
      {checkPermission("Ticket", "menu_permission") && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/ticket"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Tickets")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("Tickets")}
          >
            <button className="d-flex" style={fullViewButtonStyle}>
              <img
                src={selectedTab === "Tickets" ? ticketMenuActive : ticketMenu}
                alt="ticket"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Tickets" ? menuColorActive : menuColorInactive
              }
            >
              Tickets
            </div>
          </div>
        </Link>
      )}
      {checkPermission("Summary", "menu_permission") && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/summary"
        >
          <div
            onMouseEnter={() => handleMouseEnter("summary")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("summary")}
          >
            <button className="d-flex" style={fullViewButtonStyle}>
              <img
                src={selectedTab === "summary" ? selectSummaryIc : summaryIc}
                alt="summary"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "summary" ? menuColorActive : menuColorInactive
              }
            >
              Summary
            </div>
          </div>
        </Link>
      )}
      {checkPermission("Workload", "menu_permission") && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/workload"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Workload")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("Workload")}
          >
            <button className="d-flex" style={fullViewButtonStyle}>
              <img
                src={selectedTab === "Workload" ? workloadActive : workloadIc}
                alt="workload"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Workload" ? menuColorActive : menuColorInactive
              }
            >
              Workload
            </div>
          </div>
        </Link>
      )}
      {checkPermission("Budget", "menu_permission") && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/budget"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Budget")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("Budget")}
          >
            <button className="d-flex" style={fullViewButtonStyle}>
              <img
                src={selectedTab === "Budget" ? budgetActive : budgetIc}
                alt="budget"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Budget" ? menuColorActive : menuColorInactive
              }
            >
              Budget
            </div>
          </div>
        </Link>
      )}
      {checkPermission("Report", "menu_permission") && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/report"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Report")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("Report")}
          >
            <button className="d-flex" style={fullViewButtonStyle}>
              <img
                src={selectedTab === "Report" ? reportMenuActive : reportMenu}
                alt="report"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Report" ? menuColorActive : menuColorInactive
              }
            >
              Report
            </div>
          </div>
        </Link>
      )}

      {/* {(checkPermission("Junk Mail", "menu_permission") || checkPermission("Junk mail", "menu_permission") || true) && (
        <Link
          style={{
            textDecoration: "none",
            marginTop: "4px",
            marginBottom: "4px",
          }}
          to="/junk-mail"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Junk Mail")}
            onMouseLeave={handleMouseLeave}
            style={fullViewRowStyle("Junk Mail")}
          >
            <button className="d-flex" style={fullViewButtonStyle}>
              <img
                src={selectedTab === "Junk Mail" ? junkMailActive : junkMailInactive}
                alt="junk-mail"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Junk Mail" ? menuColorActive : menuColorInactive
              }
            >
              Junk Mail
            </div>
          </div>
        </Link>
      )} */}

      <Link
        style={{
          textDecoration: "none",
          marginTop: "4px",
          marginBottom: "4px",
        }}
        to="/whats-new"
      >
        <div
          onMouseEnter={() => handleMouseEnter("WhatsNew")}
          onMouseLeave={handleMouseLeave}
          style={{
            marginTop: "4px",
            marginBottom: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            width: "205px",
            height: "40px",
            borderRadius: "12px",
            background: "linear-gradient(270deg, #DECDFF 0%, #F4EFFF 100%)",
          }}
        >
          <button
            className="d-flex"
            style={{
              textDecoration: "none",
              border: "none",
              width: "46px",
              height: "40px",
              borderRadius: "12px",
              padding: "4px 40px 4px 8px",
              textAlign: "center",
              alignItems: "center",
              background: "transparent",
            }}
          >
            <img
              src={whatsNewGif}
              alt="WhatsNew"
              className="sideimg1"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
          <div
            style={{
              ...(selectedTab === "WhatsNew"
                ? menuColorActive
                : menuColorInactive),
              color: "#6929E2",
            }}
          >
            Whats New
          </div>
        </div>
      </Link>

      {hasAnyPermission([
        ["Handover", "menu_permission"],
        ["Team", "menu_permission"],
        ["Project", "menu_permission"],
        ["Client", "menu_permission"],
        ["Vendor", "menu_permission"],
        ["Component", "menu_permission"],
        ["Mail configuration", "menu_permission"],
        ["Approval", "menu_permission"],
        ["Escalation", "menu_permission"],
        ["Field configuration", "menu_permission"],
      ]) && (
        <div
          style={{
            fontSize: "12.5px",
            fontWeight: "500",
            color: "#8790A1",
            marginTop: "16px",
          }}
        >
          Masters
        </div>
      )}

      {/* {(checkPermission("Handover", "menu_permission") || checkPermission("Client", "menu_permission") || true) && (
        <Link
          style={{ textDecoration: "none" }}
          to="/handover"
          className="projectMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Handover")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Handover" || hoveredTab === "Handover"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Handover" ? handoverActive : handoverInactive}
                alt="handover"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Handover" ? menuColorActive : menuColorInactive
              }
            >
              Handover
            </div>
          </div>
        </Link>
      )} */}
      {checkPermission("Client", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/client/list"
          className="projectMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Client")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Client" || hoveredTab === "Client"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Client" ? clientActive : client}
                style={{
                  width: "20px",
                  height: "20px",
                  top: "3px",
                  marginLeft: "11px",
                  marginRight: "13px",
                }}
                alt="Client"
              />
            </button>
            <div
              style={
                selectedTab === "Client" ? menuColorActive : menuColorInactive
              }
            >
              Client
            </div>
          </div>
        </Link>
      )}

      {checkPermission("Project", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/project"
          className="projectMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Project")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Project" || hoveredTab === "Project"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Project" ? projectActive : project}
                alt="Project"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Project" ? menuColorActive : menuColorInactive
              }
            >
              Project
            </div>
          </div>
        </Link>
      )}

      {checkPermission("Team", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/team"
          className="teamMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Team")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Team" || hoveredTab === "Team"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Team" ? teamActive : team}
                alt="Team"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Team" ? menuColorActive : menuColorInactive
              }
            >
              Team
            </div>
          </div>
        </Link>
      )}

      {checkPermission("Vendor", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/vendor/list"
          className="projectMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Vendor")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Vendor" || hoveredTab === "Vendor"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Vendor" ? projectActive : project}
                style={{
                  width: "20px",
                  height: "20px",
                  top: "3px",
                  marginLeft: "11px",
                  marginRight: "13px",
                }}
                alt="Vendor"
              />
            </button>
            <div
              style={
                selectedTab === "Vendor" ? menuColorActive : menuColorInactive
              }
            >
              Vendor
            </div>
          </div>
        </Link>
      )}

      {checkPermission("Component", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/component"
          className="componentMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Component")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Component" || hoveredTab === "Component"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Component" ? componentActive : component}
                alt="component"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Component"
                  ? menuColorActive
                  : menuColorInactive
              }
            >
              Component
            </div>
          </div>
        </Link>
      )}
      {checkPermission("Mail configuration", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/mail/list"
          className="mailMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Mail Configuration")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Mail Configuration" ||
                hoveredTab === "Mail Configuration"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={selectedTab === "Mail Configuration" ? mailActive : mail}
                alt="mail"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Mail Configuration"
                  ? menuColorActive
                  : menuColorInactive
              }
            >
              Mail Configuration
            </div>
          </div>
        </Link>
      )}

      {checkPermission("Approval", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/approval/list"
          className="approvalMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Approval")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Approval" || hoveredTab === "Approval"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={
                  selectedTab === "Approval" ? approvalActive : approvalInActive
                }
                alt="approval"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Approval" ? menuColorActive : menuColorInactive
              }
            >
              Approval
            </div>
          </div>
        </Link>
      )}

      {checkPermission("Escalation", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/escalation/list"
          className="approvalMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Escalation")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Escalation" || hoveredTab === "Escalation"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={
                  selectedTab === "Escalation"
                    ? escalationActive
                    : escalationInActive
                }
                alt="escalation"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Escalation"
                  ? menuColorActive
                  : menuColorInactive
              }
            >
              Escalation
            </div>
          </div>
        </Link>
      )}
      {checkPermission("Field configuration", "menu_permission") && (
        <Link
          style={{ textDecoration: "none" }}
          to="/register/list"
          className="approvalMenu"
        >
          <div
            onMouseEnter={() => handleMouseEnter("Field configuration")}
            onMouseLeave={handleMouseLeave}
            style={{
              marginTop: "4px",
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              width: "205px",
              height: "40px",
              borderRadius: "12px",
              background:
                selectedTab === "Field configuration" ||
                hoveredTab === "Field configuration"
                  ? "#F7F7F7"
                  : "#FFFFFF",
            }}
          >
            <button
              className="d-flex"
              style={{
                textDecoration: "none",
                border: "none",
                width: "46px",
                height: "40px",
                borderRadius: "12px",
                padding: "4px 8px 4px 8px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
              }}
            >
              <img
                src={
                  selectedTab === "Field configuration"
                    ? fieldConfigActive
                    : fieldConfigInActive
                }
                alt="field configuration"
                className="sideimg1"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              style={
                selectedTab === "Field configuration"
                  ? menuColorActive
                  : menuColorInactive
              }
            >
              Field Configuration
            </div>
          </div>
        </Link>
      )}
    </div>
  );

  return (
    <div
      className={isMobileView ? "" : "d-none d-lg-block"}
      style={{
        height: "100%",
        backgroundColor: "white",
        borderRight: "0.6px solid #E5E5E5",
        position: "relative",
        width: isMobileView ? "237px" : isCollapsed ? "80px" : "237px",
        transition: "width 0.3s ease",
      }}
    >
      <div
        className="sidebar-scroll"
        style={{
          padding: isMobileView
            ? "0 16px 12px 16px"
            : isCollapsed
              ? "0"
              : "0 16px 12px 16px",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {(isCollapsed && !isMobileView) ? collapsedViewMenu() : fullViewMenu()}
      </div>
      {!isMobileView && (
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            position: "absolute",
            right: "-16px",
            top: "40px",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            background: "#FFFFFF",
            border: "1px solid #E5E5E5",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            zIndex: 10001,
            outline: "none",
          }}
        >
          {isCollapsed ? (
            <ChevronRight size={18} color="#6929E2" />
          ) : (
            <ChevronLeft size={18} color="#6929E2" />
          )}
        </button>
      )}
    </div>
  );
};

export default Sidebar;
